import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";

import { useFlagValuesSource } from "./behavior/use-flag-values-source.ts";

// ADR-006 §7: this module declares no screen of its own; it supplies the one
// flags source the platform app's shell and router read the active
// organization's flags through (`withFlagsSource`, @amtana/browser).
export const featureFlagBrowserModule: BrowserModule =
  defineBrowserModule("feature-flag").withFlagsSource(useFlagValuesSource);
